import React from "react";
import PropTypes from "prop-types";

import URLMessage from "components/URLMessage";

export function MailToMessage({ children, email, subject, keyword }) {
  return (
    <URLMessage
      params={subject}
      keywords={[
        {
          keyword: keyword,
          url: `mailto:${email}`,
          ...(subject ? { params: `subject=${subject}` } : {}),
        },
      ]}
    >
      {children}
    </URLMessage>
  );
}

MailToMessage.propTypes = {
  children: PropTypes.node,
  keyword: PropTypes.string,
  subject: PropTypes.string,
  email: PropTypes.string,
};

MailToMessage.defaultProps = {
  children: null,
  keyword: "support",
  subject: undefined,
  email: "support@myhubly.com",
};

export default MailToMessage;
